module.exports = __webpack_public_path__ + "images/59d694a990c1c63d0ffd86327d0235fa-students1.jpg";